export const ITC_OP_TYPES = {
  FORCE_SYNC: 'FORCE_SYNC', // 강제 동기화를 요청한다 해당 메시지를 받은 탭은 항상 동기화를 진행해야한다. (브라우저마다 비활성화 브라우저가 동작이 일시정지되어있는 경우 있음)
  SYNC: 'SYNC', // 데이터 동기화
  EVAL: 'EVAL' // JS 명령 수행
}

export default ITC_OP_TYPES